/*
 * ===============================================================================================================
 *                                Copyright 2024, Blue Yonder Group, Inc.
 *                                           All Rights Reserved
 *
 *                               THIS IS UNPUBLISHED PROPRIETARY SOURCE CODE OF
 *                                          BLUE YONDER GROUP, INC.
 *
 *
 *                         The copyright notice above does not evidence any actual
 *                                 or intended publication of such source code.
 *
 * ===============================================================================================================
 */
const MESSAGES = {
  NO_ORGANIZATION: "No Organizations To Display",
  DELETE_ORGANIZATION_TITLE: "Are you sure you want to delete the organization ",
  SELECT_ORGANIZATION: "Select Organization",
  NO_ORGANIZATION_SELECTED: "No organization selected",
};

const TITLES = {
  ORGANIZATION: "Organization",
  ORGANIZATIONS: "Organizations",
  ADD_ORGANIZATION: "Add Organization",
  ORGANIZATION_NAME: "Organization Name",
  ORGANIZATION_ID: "Organization ID",
  EDIT_ORGANIZATION: "Edit Organization",
  DELETE_ORGANIZATION: "Delete Organization",
  SELECT_ORGANIZATION: "Select Organization",
  CANCEL: "Cancel",
  EDIT: "Edit",
  DELETE: "Delete",
};

export const PAGE_SIZE_ORGANIZATIONS = 50;

export { MESSAGES, TITLES };
